export default __webpack_public_path__ + "static/media/crop_type_wheat.a6dd4418.jpg";